module.exports = __webpack_public_path__ + "static/modelprint-da16a7f7a3c422fd001b1b7eb11ee942.jpg";